import type { ScreenBase } from "@frui.ts/screens/dist";
import { ConductorOneChildActive, Router } from "@frui.ts/screens/dist";
import { computed } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import CzechStatisticalOfficeReportsListViewModel from "./czechStatisticalOfficeReports/czechStatisticalOfficeReportsListViewModel";
import MinistryOfFinanceReportsListViewModel from "./ministryOfFinanceReports/ministryOfFinanceReportsListViewModel";
import MinistryOfTransportReportsListViewModel from "./ministryOfTransportReports/ministryOfTransportReportsListViewModel";

const navigationName = "external-reports";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [
    CzechStatisticalOfficeReportsListViewModel,
    MinistryOfFinanceReportsListViewModel,
    MinistryOfTransportReportsListViewModel,
  ],
})
export default class ExternalReportsViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private localizationService: LocalizationService,
    private czechStatisticalOfficeReportsListViewModel: CzechStatisticalOfficeReportsListViewModel,
    private ministryOfFinanceReportsListViewModel: MinistryOfFinanceReportsListViewModel,
    private ministryOfTransportReportsListViewModel: MinistryOfTransportReportsListViewModel
  ) {
    super();
    this.navigationName = navigationName;

    this.children.push(
      this.czechStatisticalOfficeReportsListViewModel,
      this.ministryOfFinanceReportsListViewModel,
      this.ministryOfTransportReportsListViewModel
    );
  }

  protected onInitialize(): Promise<any> | void {
    this.tryActivateChild(this.children[0]);
    return super.onInitialize();
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.timeCharges, `externalReports.${code}`, size);
  }

  @computed
  get name() {
    return this.translate("name");
  }
}
